import { Box } from "@mui/material";

import OfferredCustomers from "./OfferedCustomer";
import AcceptedCustomers from "./AcceptedCustomer";
import ActiveCustomers from "./ActiveCustomer";

const PortfolioPartnerSolution = ({ offeredCustomerData, acceptedCustomerData, activeCustomerData, onClick }) => {
  return (
    <Box>
      <OfferredCustomers data={offeredCustomerData} onClick={onClick} />
      <AcceptedCustomers data={acceptedCustomerData} onClick={onClick} />
      <ActiveCustomers data={activeCustomerData} onClick={onClick} />
    </Box>
  );
};

export default PortfolioPartnerSolution;
